import { graphql, useStaticQuery } from 'gatsby'

const useLocationsListQuery = () => {
  const data = useStaticQuery(graphql`
    {
      locationsList: allAirtableLocations(
        sort: { fields: rowIndex, order: ASC }
      ) {
        nodes {
          data {
            name
            address1
            address2
            lat
            lng
            website
          }
        }
      }
    }
  `)

  return data.locationsList.nodes
    ?.map(({ data }) => ({
      title: data.name,
      address1: data.address1,
      address2: data.address2,
      coords: {
        lat: data.lat,
        lng: data.lng,
      },
      website: data.website,
    }))
    .sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()))
}

export default useLocationsListQuery
